import { useNavigate } from "react-router-dom";
import { IMAGE_HOST } from "../../../constants";
import ActionsDropdown from "./ActionsDropdown";

import {
  formatDate,
  resourcePersonId,
  statusBadgeClass,
} from "./resourcePersonUtils";

const ResourcePersonTable = ({
  users,
  isReloading,
  onToggleStatus,
  onView,
  onUpdate,
}) => {
  const navigate = useNavigate();

  // Navigate to a sub-page for this resource person (earnings / resources / students).
  const goToPage = (user, section) => {
    const id = resourcePersonId(user);
    if (!id) return;
    navigate(`/admin/resource-persons/${id}/${section}`);
  };

  return (
    <div className="overflow-x-auto">
      <table className="table mb-0 align-middle" style={{ minWidth: "980px" }}>
        <thead>
          <tr>
            <th></th>
            <th>Email</th>
            <th>Name</th>
            <th>Status</th>
            <th style={{ minWidth: "110px" }}>Date Added</th>
            <th>Phone</th>
            <th style={{ minWidth: "120px" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {isReloading && (
            <tr>
              <td colSpan={7}>
                <div className="d-flex justify-content-center align-items-center tableLoader">
                  <div className="loader"></div>
                </div>
              </td>
            </tr>
          )}
          {!isReloading && users.length === 0 && (
            <tr>
              <td colSpan={7}>
                <div className="d-flex justify-content-center align-items-center tableLoader">
                  No Resource Persons to display
                </div>
              </td>
            </tr>
          )}

          {users.map((user, index) => (
            <tr key={index}>
              <td>
                {user.AdminProfile && user.AdminProfile.image ? (
                  <div className="adminProfileImage mx-2 s-35">
                    <img
                      src={`${IMAGE_HOST}${user.AdminProfile.image}`}
                      className="s-31"
                      alt="Profile"
                    />
                  </div>
                ) : (
                  <div className="adminProfileImage mx-2 s-35">
                    <img src="/images/default_profile.png" className="s-31" alt="Profile" />
                  </div>
                )}
              </td>
              <td className="text-start">{user.email}</td>
              <td>{user.name}</td>
              <td>
                <span className={statusBadgeClass(user.status)}>
                  {user.status || "--"}
                </span>
              </td>
              <td>{formatDate(user.createdAt)}</td>
              <td>{user.phone || "--"}</td>
              <td>
                <ActionsDropdown
                  items={[
                    { label: "Status", onClick: () => onToggleStatus(user) },
                    { label: "View", onClick: () => onView(user) },
                    { label: "Earnings", onClick: () => goToPage(user, "earnings") },
                    { label: "Resources", onClick: () => goToPage(user, "resources") },
                    { label: "Students", onClick: () => goToPage(user, "students") },
                    { label: "Update", onClick: () => onUpdate(user) },
                  ]}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ResourcePersonTable;
